// src\routers\router.jsx
import { createBrowserRouter } from 'react-router-dom';

// Layouts
import RootLayout from '../layouts/RootLayout';
import MainLayout from '../layouts/MainLayout';
import CustomLayout from '../layouts/CustomLayout';
import AdminLayout from '../layouts/AdminLayout';

// Public Pages
import Home from '../pages/Home';
import Portfolio from '../pages/Portfolio';
import PortfolioDetail from '../pages/PortfolioDetail';
import ServiceDetail from '../pages/ServiceDetail';
import SubscriptionDetail from '../pages/SubscriptionDetail';
import Services from '../pages/Services';
import About from '../pages/About';
import Contact from '../pages/Contact';
import HireMe from '../pages/HireMe';
import Login from '../pages/Login';
import SubscriptionHire from '../pages/SubscriptionHire';
import PublicProfile from '../pages/PublicProfile';
import Illustration from '../pages/Illustration';
import IllustrationDetail from '../pages/IllustrationDetail';

// Blog Public Pages
import BlogHome from '../pages/blog/BlogHome';
import BlogPost from '../pages/blog/BlogPost';
import BlogCategory from '../pages/blog/BlogCategory';
import BlogTag from '../pages/blog/BlogTag';

// Admin Pages
import DashboardHome from '../pages/admin/DashboardHome';
import ProjectsManagement from '../pages/admin/ProjectsManagement';
import HireInquiries from '../pages/admin/HireInquiries';
import ReadyMadeInquiries from '../pages/admin/ReadyMadeInquiries';
import ReadyMadeServices from '../pages/admin/ReadyMadeServices';
import SubscriptionPlans from '../pages/admin/SubscriptionPlans';
import SubscriptionInquiries from '../pages/admin/SubscriptionInquiries';
import ContactMessages from '../pages/admin/ContactMessages';
import Analytics from '../pages/admin/Analytics';
import Settings from '../pages/admin/Settings';
import ReviewsManagement from '../pages/admin/ReviewsManagement';
import BlogManagement from '../pages/admin/BlogManagement';

// Route Guards
import AdminRoute from '../components/AdminRoute';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsConditions from '../pages/TermsConditions';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      // ==================== PUBLIC ROUTES (with header/footer) ====================
      {
        element: <MainLayout />,
        children: [
          { index: true, element: <Home /> },
          { path: 'portfolio', element: <Portfolio /> },
          { path: 'portfolio/:id', element: <PortfolioDetail /> },
          { path: 'services', element: <Services /> },
          { path: 'service/:id', element: <ServiceDetail /> },
          { path: 'blog', element: <BlogHome /> },
          { path: 'blog/:slug', element: <BlogPost /> },
          { path: 'blog/category/:category', element: <BlogCategory /> },
          { path: 'blog/tag/:tag', element: <BlogTag /> },
          { path: 'about', element: <About /> },
          { path: 'contact', element: <Contact /> },
          { path: 'subscription', element: <SubscriptionHire /> },
          { path: 'subscription/:id', element: <SubscriptionDetail /> },
          { path: 'hire', element: <HireMe /> },
          { path: ':username', element: <PublicProfile /> },
          { path: 'privacy-policy', element: <PrivacyPolicy /> },
          { path: 'terms', element: <TermsConditions /> },
          { path: 'illustrations', element: <Illustration /> },
          { path: 'illustrations/:id', element: <IllustrationDetail /> },
        ],
      },

      // ==================== PUBLIC ROUTES (without header/footer) ====================
      {
        element: <CustomLayout />,
        children: [{ path: 'wdalogin', element: <Login /> }],
      },

      // ==================== ADMIN ROUTES (protected) ====================
      {
        element: <AdminRoute />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              // Dashboard
              { index: true, element: <DashboardHome /> },
              { path: 'admin', element: <DashboardHome /> },
              { path: 'admin/dashboard', element: <DashboardHome /> },

              // Portfolio Management
              { path: 'admin/portfolio', element: <ProjectsManagement /> },

              // Blog Management
              { path: 'admin/blog', element: <BlogManagement /> },

              // Inquiries Management
              { path: 'admin/inquiries/hire', element: <HireInquiries /> },
              {
                path: 'admin/inquiries/ready-made',
                element: <ReadyMadeInquiries />,
              },
              {
                path: 'admin/ready-made-services',
                element: <ReadyMadeServices />,
              },
              {
                path: 'admin/subscription-plans',
                element: <SubscriptionPlans />,
              },
              {
                path: 'admin/inquiries/subscription',
                element: <SubscriptionInquiries />,
              },
              { path: 'admin/inquiries/contact', element: <ContactMessages /> },

              // Reviews Management
              { path: 'admin/reviews', element: <ReviewsManagement /> },

              // Analytics
              { path: 'admin/analytics', element: <Analytics /> },

              // Settings
              { path: 'admin/settings', element: <Settings /> },
            ],
          },
        ],
      },
    ],
  },
]);
